// @ts-nocheck
import { shadowOrDocumentBody } from '../utils/shadowDomUtils';
var DomHandler = /*#__PURE__*/function () {
  function DomHandler() {}
  DomHandler.alignOverlay = function alignOverlay(overlay, target, appendTo, spacing, dropdownAlwaysDown, calculateMinWidth, horizontalAlign) {
    if (dropdownAlwaysDown === void 0) {
      dropdownAlwaysDown = true;
    }
    if (calculateMinWidth === void 0) {
      calculateMinWidth = true;
    }
    if (overlay && target) {
      if (appendTo === 'self') {
        this.relativePosition(overlay, target, spacing, dropdownAlwaysDown, horizontalAlign);
      } else {
        calculateMinWidth && (overlay.style.minWidth = DomHandler.getOuterWidth(target) + 'px');
        this.absolutePosition(overlay, target, appendTo, spacing, dropdownAlwaysDown, horizontalAlign);
      }
    }
  };
  DomHandler.absolutePosition = function absolutePosition(element, target, appendTo, spacing, dropdownAlwaysDown, horizontalAlign) {
    if (element) {
      var elementDimensions = element.offsetParent ? {
        width: element.offsetWidth,
        height: element.offsetHeight
      } : this.getHiddenElementDimensions(element);
      var elementOuterHeight = elementDimensions.height;
      var elementOuterWidth = elementDimensions.width;
      var targetOuterHeight = target.offsetHeight;
      var targetOuterWidth = target.offsetWidth;
      var targetOffset = target.getBoundingClientRect();
      var windowScrollTop = this.getWindowScrollTop();
      var windowScrollLeft = this.getWindowScrollLeft();
      var viewport = this.getViewport();
      var top, left;
      var targetNode = null;
      if (appendTo && appendTo.node) {
        var _appendTo$node;
        targetNode = (_appendTo$node = appendTo.node) === null || _appendTo$node === void 0 ? void 0 : _appendTo$node.getRootNode();
      } else if (appendTo && !appendTo.hasOwnProperty('node')) {
        targetNode = appendTo === null || appendTo === void 0 ? void 0 : appendTo.getRootNode();
      }
      var rootLeft = 0;
      var rootTop = 0;
      if (targetNode && targetNode instanceof DocumentFragment) {
        var root = shadowOrDocumentBody(target);
        if (root.host) root = root.host;
        var rootOffset = root.getBoundingClientRect();
        rootTop = rootOffset.top > 0 ? rootOffset.top : 0;
        rootLeft = rootOffset.left > 0 ? rootOffset.left : 0;
      }
      if (!dropdownAlwaysDown) {
        if (targetOffset.top + targetOuterHeight + elementOuterHeight + spacing > viewport.height) {
          top = targetOffset.top + windowScrollTop - elementOuterHeight - spacing - rootTop;
          if (top < 0) {
            top = windowScrollTop;
            element.style.top = top + 'px';
          } else {
            var bottom = element.offsetParent.offsetHeight - windowScrollTop - targetOffset.top - targetOuterHeight;
            element.style.top = 'unset';
            element.style.bottom = bottom + targetOuterHeight + spacing + 'px';
          }
        } else {
          top = targetOuterHeight + targetOffset.top + windowScrollTop - rootTop;
          element.style.top = top + spacing + 'px';
          element.style.bottom = 'unset';
          element.style.transformOrigin = 'top';
        }
      } else {
        top = targetOuterHeight + targetOffset.top + windowScrollTop + spacing - rootTop;
        left = '0px';
        element.style.bottom = 'unset';
        element.style.top = top + 'px';
        element.style.left = left + 'px';
      }
      if (!horizontalAlign) {
        if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width) left = Math.max(0, targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth - rootLeft);else left = targetOffset.left + windowScrollLeft - rootLeft;
      } else {
        if (horizontalAlign === 'left') {
          left = targetOffset.left + windowScrollLeft - rootLeft;
        } else {
          left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth - rootLeft;
        }
      }
      element.style.left = left + 'px';
    }
  };
  DomHandler.relativePosition = function relativePosition(element, target, spacing, dropdownAlwaysDown, horizontalAlign) {
    if (element) {
      var elementDimensions = element.offsetParent ? {
        width: element.offsetWidth,
        height: element.offsetHeight
      } : this.getHiddenElementDimensions(element);
      var targetHeight = target.offsetHeight;
      var targetOffset = target.getBoundingClientRect();
      var viewport = this.getViewport();
      var top, left;
      if (!dropdownAlwaysDown) {
        // down
        if (targetOffset.top + targetHeight + elementDimensions.height + spacing > viewport.height) {
          if (targetOffset.top + elementDimensions.height * -1 + spacing * -1 > 0) {
            // up
            var bottom = targetHeight + spacing;
            element.style.top = 'unset';
            element.style.bottom = bottom + 'px';
            element.style.transformOrigin = 'bottom';
            return;
          }
        } else {
          top = targetHeight + spacing;
          element.style.bottom = 'unset';
          element.style.top = top + 'px';
          element.style.transformOrigin = 'top';
        }
        if (elementDimensions.width > viewport.width) {
          // element wider then viewport and cannot fit on screen (align at left side of viewport)
          left = targetOffset.left * -1;
        } else if (targetOffset.left + elementDimensions.width > viewport.width) {
          // element wider then viewport but can be fit on screen (align at right side of viewport)
          left = (targetOffset.left + elementDimensions.width - viewport.width) * -1;
        } else {
          // element fits on screen (align with target)
          left = 0;
        }
        element.style.top = top + 'px';
        element.style.left = left + 'px';
      } else {
        element.style.top = targetHeight + spacing + 'px';
        element.style.left = '0px';
      }
    }
  };
  DomHandler.getHiddenElementDimensions = function getHiddenElementDimensions(element) {
    var dimensions = {};
    if (element) {
      element.style.visibility = 'hidden';
      element.style.display = 'block';
      dimensions.width = element.offsetWidth;
      dimensions.height = element.offsetHeight;
      element.style.display = 'none';
      element.style.visibility = 'visible';
    }
    return dimensions;
  };
  DomHandler.getViewport = function getViewport() {
    var win = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      w = win.innerWidth || e.clientWidth || g.clientWidth,
      h = win.innerHeight || e.clientHeight || g.clientHeight;
    return {
      width: w,
      height: h
    };
  };
  DomHandler.getOuterWidth = function getOuterWidth(el, margin) {
    if (el) {
      var width = el.offsetWidth || el.getBoundingClientRect().width;
      if (margin) {
        var style = getComputedStyle(el);
        width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      }
      return width;
    }
    return 0;
  };
  DomHandler.getWindowScrollTop = function getWindowScrollTop() {
    var doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
  };
  DomHandler.getWindowScrollLeft = function getWindowScrollLeft() {
    var doc = document.documentElement;
    return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
  };
  return DomHandler;
}();
export { DomHandler as default };